import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  width = "100%",
  viewBox = "0 0 32 32"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M.5 24a.5.5 0 0 1-.5-.517 10.586 10.586 0 0 1 1.049-4.257c.737-1.475 3.243-2.397 6.712-3.672l.057-.021L9 15.096v-2.413a4.256 4.256 0 0 1-1.489-2.93c-.316-.27-.46-.752-.51-.962-.151-.638-.117-1.53.433-2.056-.015-.054-.033-.111-.05-.166-.314-1.039-.969-3.199-.1-4.37.314-.423.775-.67 1.373-.737C9.247.388 11.1 0 12.684 0c.079 0 .159.001.238.003 1.9.045 4.236.686 4.568 2.342.281 1.411-.431 3.207-.814 4.172l-.093.237c.532.529.563 1.408.415 2.037-.05.21-.193.693-.51.962a4.26 4.26 0 0 1-1.489 2.93v2.413l1.236.457c3.469 1.276 5.976 2.198 6.711 3.667a10.58 10.58 0 0 1 1.052 4.264.503.503 0 0 1-.14.365.502.502 0 0 1-.358.151H.5zm22.469-1a9.58 9.58 0 0 0-.919-3.34c-.554-1.108-3.152-2.063-6.158-3.169-.506-.186-1.03-.378-1.567-.58a.502.502 0 0 1-.325-.468v-3c0-.156.075-.306.2-.4a3.264 3.264 0 0 0 1.3-2.6.5.5 0 0 1 .375-.484c.067-.109.186-.391.201-.769.006-.149.002-.649-.3-.8a.497.497 0 0 1-.276-.447c0-.172.072-.354.247-.794.345-.869.987-2.486.763-3.608-.201-1.002-2.012-1.5-3.611-1.538A7.815 7.815 0 0 0 12.684 1c-1.836 0-3.068.541-3.199 1.064A.5.5 0 0 1 9 2.443c-.445 0-.735.112-.913.352-.569.767.008 2.671.254 3.484.109.358.159.522.159.664a.497.497 0 0 1-.276.447c-.302.151-.306.65-.3.8.016.389.139.668.206.769.215.052.37.246.37.484 0 1.018.486 1.99 1.3 2.6.125.094.2.243.2.4v3c0 .207-.13.395-.324.468-.538.202-1.062.394-1.569.581-3.007 1.105-5.603 2.06-6.16 3.174A9.558 9.558 0 0 0 1.031 23h21.938z"
    />
  </svg>
);

export default SVG;
